import { Component } from '@angular/core';
import { Router, RouterLink, RouterModule, RouterOutlet } from '@angular/router';
import { ConstantsService } from '../../constants/constants.service';
import { HttpService } from '../../services/http.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { VisitUpdateService } from '../../services/VisitUpdateService';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { QrScannerComponent } from '../qr-scanner/qr-scanner.component';
import { NotificationWebsocketService } from '../../services/notification-websocket.service';
import { ProfileUpdateService } from '../../services/ProfileUpdateService';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, RouterLink, FormsModule, CommonModule,QrScannerComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  host: { id: 'sidebar' },
})
export class SidebarComponent {
  VisitStatusCounts: any[] = [];
  AllVisitorStatusCounts: any = {};
  private visitUpdateSubscription: Subscription = new Subscription();
  roleName: string = '';
  keyRole: string = '';
  user: any;
  openScanner: boolean = false;
  currentDate: Date = new Date();
  private visitUpdateSub: Subscription | null = null;
  isManager: boolean = false;
  pendingManagerCount: number = 0;
  todaysVisitsCount: number = 0;

  constructor(
    public constants: ConstantsService,
    private router: Router,
    private httpService: HttpService,
    private toastr: ToastrService,
    private visitUpdateService: VisitUpdateService,
    private wsService: NotificationWebsocketService,
    private profileUpdateService: ProfileUpdateService
  ) {}

  ngOnInit(): void {
    
    setInterval(() => {
      this.currentDate = new Date();
    }, 1000);

    const storage = this.constants.getSession();
    if (storage) {
      this.roleName = storage.role.name;
      this.keyRole = storage.role.keyRole;
    }
    this.getVisitStatusCounts();
    this.refreshVisitorCounts();
    this.refreshTodaysVisitsCount();
    this.isUserManager();
    this.getPendingManagerApprovalCount();

    this.wsService.connect(storage.email);
    // Subscribe to updates
    this.visitUpdateSub = this.wsService
      .getVisitUpdates()
      .subscribe((update) => {
        console.log('Received visit update:', update);
        this.getVisitStatusCounts();
        this.refreshVisitorCounts(); 
        this.refreshTodaysVisitsCount();
        this.getPendingManagerApprovalCount();
      });
   

    // Subscribe to visit update events
    this.visitUpdateSubscription =
      this.visitUpdateService.visitUpdated$.subscribe(() => {
        this.getVisitStatusCounts();
        this.refreshVisitorCounts();
        this.refreshTodaysVisitsCount();
        this.getPendingManagerApprovalCount();
      });
 
      this.visitUpdateService.sidebarCountUpdated$.subscribe(() => {
        this.getVisitStatusCounts();
        this.refreshVisitorCounts();
        this.refreshTodaysVisitsCount();
        this.getPendingManagerApprovalCount();
      });
    
    this.user = this.constants.getSession();
    this.roleName = this.user.role.name;
    this.profileUpdateService.profileUpdated$.subscribe(() => {
      const updatedUser = this.constants.getSession();
      this.roleName = updatedUser?.role?.name || '';
      this.keyRole = updatedUser?.role?.keyRole || '';
      this.user = updatedUser;

      // re-run counts now that keyRole is correct
      this.refreshVisitorCounts();
      this.refreshTodaysVisitsCount();
      this.getVisitStatusCounts();
      this.getPendingManagerApprovalCount();
    });
  }
  ngOnDestroy(): void {
  this.visitUpdateSubscription?.unsubscribe();
  this.visitUpdateSub?.unsubscribe();
  this.wsService.disconnect();
  }
  getVisitStatusCounts(): void {
    this.httpService
      .getRequest(this.constants.SERVER_URLS['VISITS_STATUS_COUNT'])
      .subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.VisitStatusCounts = res.result;
        } else {
          this.toastr.error(res.message, 'Error');
        }
      });
  }
  getALLVisitorCounts(): void {
    this.httpService
      .getRequest(this.constants.SERVER_URLS['ALL_VISITORS_COUNT'])
      .subscribe((res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.AllVisitorStatusCounts = res.result;
        } else {
          this.toastr.error(res.message, 'Error');
        }

      });
  }

  isUserManager(): void {
  this.httpService
    .getRequest(this.constants.SERVER_URLS['IS_USER_MANAGER'])
    .subscribe((res: any) => {
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.isManager = res.result === true;
      } else {
        this.isManager = false;
        this.toastr.error(res.message, 'Error');
      }
    }, () => {
      this.isManager = false;
    });
}

getPendingManagerApprovalCount(): void {
  this.httpService
    .getRequest(this.constants.SERVER_URLS['GET_PENDING_MANAGER_APPROVAL_COUNT'])
    .subscribe(
      (res: any) => {
        if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
          this.pendingManagerCount = res.result || 0;
        } else {
          this.pendingManagerCount = 0;
          this.isManager = false;
          this.toastr.error(res.message, 'Error');
        }
      },
      () => {
        this.pendingManagerCount = 0;
        this.isManager = false;
      }
    );
}


 getCount(status: string): number {
  const item = this.VisitStatusCounts.find((s: any) => s.status === status);
  return item ? item.count : 0;
}


  logout() {
    this.wsService.disconnect();
    this.constants.clearSession();
    this.router.navigate(['/login']);
    this.closeSidebar();
  }
  closeSidebar() {
    const wrapper = document.getElementById('main-wrapper');
    if (wrapper) {
      wrapper.classList.remove('show-sidebar');
    }
  }
  viewVisitsByStatus(status: string) {
    this.closeSidebar();
    this.router.navigate(['visit-list'], {
      queryParams: {
        status: status,
      },
    });
  }
   viewManageVisits(status: string) {
    this.closeSidebar();
    this.router.navigate(['visit-list'], {
      queryParams: {
        status: status,
      },
    });
  }

   handleScan(event: any) {
  const result = event?.detail?.result;
  if (result) {
    console.log('Scanned from header:', result);
  }
  this.openScanner = false;
}
handleLogoClick(event: Event): void {
  event.preventDefault();
  
  const currentUser = this.constants.getSession();
  const currentRole = currentUser?.role?.keyRole;

  if (currentRole === 'HOST') {
    this.router.navigate(['/dashboard']);
    this.closeSidebar();
  }
}

refreshVisitorCounts(): void {
  if (this.keyRole === 'SECURITY' || this.keyRole === 'RECEPTION') {
    this.getLocationVisitorCounts();
  } else {
    this.getALLVisitorCounts();
  }
}

getLocationVisitorCounts(): void {
  this.httpService
    .getRequest(this.constants.SERVER_URLS['ALL_VISITORS_COUNT_BY_LOCATION'])
    .subscribe((res: any) => {
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.AllVisitorStatusCounts = res.result;
      } else {
        this.toastr.error(res.message, 'Error');
      }
    });
}
refreshTodaysVisitsCount(): void {
  if (this.keyRole === 'SECURITY' || this.keyRole === 'RECEPTION') {
    this.getTodaysVisitsCount();
  }
}

getTodaysVisitsCount(): void {
  this.httpService
    .getRequest(this.constants.SERVER_URLS['TODAYS_VISITS_COUNT'])
    .subscribe((res: any) => {
      if (res.status === this.constants.RESPONSE_CODES['SUCCESS']) {
        this.todaysVisitsCount = res.result || 0;
      } else {
        this.todaysVisitsCount = 0;
      }
    }, () => {
      this.todaysVisitsCount = 0;
    });
}
}
